// extracted by mini-css-extract-plugin
module.exports = {"category":"Option_category__5LsvU","location":"Option_location__xplyy","scale":"Option_scale__1vgvG"};